import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { selectPaymentMethodsListItems } from "../../../../../../redux/payment-methods/selector";
import { paymentMethods } from "../../../../../../redux/payment-methods/action";
import Table from "../../../../../../common/components/table";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate } from "react-router-dom";

const ManagementPaymentMethods = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const paymentMethodItems = useSelector(selectPaymentMethodsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'RazorPayConfiguration.RazorPayConfigurationPId', headerName: 'RazorPay Configuration PId'},
      { field: 'RazorPayConfiguration.GatewayName', headerName: 'GatewayName' },
      { field: 'RazorPayConfiguration.GatewayKey', headerName: 'GatewayKey' }
      
        ]);
      }
    
	useEffect(() => {
        createColumnDefs()
		dispatch(paymentMethods.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods/query-by-tenants`,entity:'paymentMethods',jsonData:{
            Tenants: [
                {
                  Id: 0
                }
              ] 
        }}))
	}, [])

  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }
  const handleDelete=(data: any)=>{

  } 
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const additionButtons: any = [
    {
      name: 'Add PaymentMethod',
      callback: () => handleAdd(),
    }
  ];
	return (
    <>
    {paymentMethodItems?.isLoading ? 
    <PageLoader />
: 
		<Table columnData={columnDefs} rowData={paymentMethodItems?.result?.items} 
    onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Payment Methods" />
  }
  </>  
	);
};

export default ManagementPaymentMethods;


